export default function(job) {
  let parsedJob = {};

  // Add static Google values
  addJobStaticData(parsedJob);

  mapValue(job, 'externalPostingName', 'title', parsedJob);
  mapValue(job, 'jobAdText', 'description', parsedJob);
  setIdentifier(job, parsedJob);
  setHiringOrganization(job, parsedJob);
  setJobLocation(job, parsedJob);
  mapEmploymentTypes(job, parsedJob);

  parsedJob['datePosted'] = formatDate(job['jobStartDate']);
  clean(parsedJob);

  return JSON.stringify(parsedJob, null, 2);
}


/**
 * @param job
 * @param jobKey
 * @param parsedKey
 * @param parsedJob
 */
function mapValue(job, jobKey, parsedKey, parsedJob) {
  if (job?.hasOwnProperty(jobKey)) {
    parsedJob[parsedKey] = job[jobKey];
  }
}

/**
 * @param job
 * @param parsedJob
 */
function mapEmploymentTypes(job, parsedJob) {
  let workingTimes = [];
  const employmentTypes = {
    'FULL_TIME': ['Vollzeit', 'Voll- oder Teilzeit'],
    'PART_TIME': ['Teilzeit', 'Voll- oder Teilzeit'],
    'CONTRACTOR': ['Freie Mitarbeit/Projektmitarbeit'],
  };

  if (job?.hasOwnProperty('employmentType')) {
    return;
  }

  if (job?.workTimes && Array.isArray(job.workTimes)) {
    Object.keys(employmentTypes).forEach(key => {
      job.workTimes.forEach(workingTime => {
        if (employmentTypes[key].includes(workingTime)) {
          workingTimes.push(key);
        }
      });
    });
    parsedJob['employmentType'] = workingTimes;
  }
}

/**
 * Format data to Y-m-d
 */
function formatDate(timestamp) {
  let d = new Date(parseInt(timestamp));
  return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
}

/**
 Add identifier section, required by Google
 */
function setIdentifier(job, parsedJob) {
  if (!job?.hasOwnProperty('jobDbId')) {
    return;
  }

  parsedJob['identifier'] = {
    '@type': 'PropertyValue',
    name: 'Google',
    value: job['jobDbId'],
  };
}

/**
 * Add hiring (company) section, required by Google
 * @param job
 * @param parsedJob
 */
function setHiringOrganization(job, parsedJob) {
  parsedJob['hiringOrganization'] = {
    '@type': 'Organization',
    name: job['company_name'],
    sameAs: job['job_ad_url'],
  };
}

/**
 * Add location section, required by Google
 * @param job
 * @param parsedJob
 */
function setJobLocation(job, parsedJob) {
  parsedJob['jobLocation'] = {
    '@type': 'Place',
    address: {
      '@type': 'PostalAddress',
      streetAddress: job['geo_street'],
      addressLocality: job['geo_city'],
      addressRegion: job['geo_state'],
      postalCode: job['geo_zip'],
      addressCountry: job['geo_country'],
    },
  };
}

/**
 * Add location section, required by Google
 * @param parseJob
 */
function addJobStaticData(parseJob) {
  parseJob['@context'] = 'https://schema.org/';
  parseJob['@type'] = 'JobPosting';
}

/**
 * @param obj
 */
function clean(obj) {
  for (const propName in obj) {
    if (typeof obj[propName] == 'object') {
      clean(obj[propName]);
    } else if (obj[propName] === null || obj[propName] === undefined || obj[propName].length < 1) {
      delete obj[propName];
    }
  }
}
